var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrapper d-flex justify-content-center" }, [
    _c(
      "div",
      {
        staticClass: "content-container d-flex flex-column align-items-center",
      },
      [
        _c("div", { staticClass: "paddle-wrapper mb-2" }, [
          _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/pricing/payment-guarantee/shield-check.svg"),
                alt: "shield check",
              },
            }),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "pages.pricing.paymentGuarantee.securePaymentsProvidedBy"
                  )
                )
              ),
            ]),
            _c("img", {
              staticClass: "paddle-logo",
              attrs: {
                src: require("@/assets/img/pricing/payment-guarantee/payment-paddle.svg"),
                alt: "paddle logo",
              },
            }),
          ]),
          _vm._m(0),
        ]),
        _c(
          "div",
          {
            staticClass:
              "money-back-wrapper d-md-flex text-center text-md-left",
          },
          [
            _c("img", {
              staticClass: "mr-md-3",
              attrs: {
                src: _vm.moneyBackImage,
                width: "99",
                height: "99",
                alt: "money back",
              },
            }),
            _c("div", [
              _c("p", { staticClass: "money-back-header mt-md-0" }, [
                _vm._v(" " + _vm._s(_vm.title) + " "),
              ]),
              _c("p", {
                staticClass: "money-back-description my-0",
                domProps: { innerHTML: _vm._s(_vm.description) },
              }),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center mt-2" }, [
      _c("img", {
        staticClass: "payment-card",
        attrs: {
          src: require("@/assets/img/pricing/payment-guarantee/payment-paypal.png"),
          alt: "paypal card",
        },
      }),
      _c("img", {
        staticClass: "payment-card",
        attrs: {
          src: require("@/assets/img/pricing/payment-guarantee/payment-visa.png"),
          alt: "visa card",
        },
      }),
      _c("img", {
        staticClass: "payment-card",
        attrs: {
          src: require("@/assets/img/pricing/payment-guarantee/payment-mastercard.png"),
          alt: "mastercard card",
        },
      }),
      _c("img", {
        staticClass: "payment-card",
        attrs: {
          src: require("@/assets/img/pricing/payment-guarantee/payment-american.png"),
          alt: "american express card",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }